import { Box, FormControl, Select, Typography, MenuItem } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useProgressPortraitContext } from './ProgressPortraitProvider';
import { useCallback } from 'react';
import { format } from 'date-fns';
import { LoadingIndicator } from '@xolv-mybrightlink/common';

export const TreatmentPeriod = () => {
  const { store, dispatch } = useProgressPortraitContext();
  const changeTreatmentPeriod = useCallback(
    (abaCaseId: string) => {
      dispatch({
        type: 'SELECT_TREATMENT_PERIOD',
        abaCaseSfId: abaCaseId,
        patientSfId: store.selectedPatientSfId,
      });
    },
    [dispatch, store.selectedPatientSfId],
  );
  const careEpisodes = store.getCareEpisodes(store.selectedPatientSfId);
  const selectedAbaCaseId = store.getSelectedAbaCaseSfId(
    store.selectedPatientSfId,
  );
  if (!careEpisodes) {
    return null;
  }
  if (
    !selectedAbaCaseId ||
    careEpisodes === 'not-load' ||
    careEpisodes === 'loading'
  ) {
    return <LoadingIndicator />;
  }
  if (careEpisodes === 'error') {
    return null;
  }
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 5,
        alignItems: 'center',
      }}
    >
      <Typography color='info.text' fontWeight={500}>
        <FormattedMessage id='progress-portrait.treatment-period' />
      </Typography>
      <FormControl sx={{ minWidth: '300' }}>
        <Select
          value={selectedAbaCaseId}
          onChange={(event) => changeTreatmentPeriod(event.target.value)}
          sx={{
            '& .MuiSelect-select': {
              py: 3,
              backgroundColor: '#fff',
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#DDE2EF',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'primary.main',
            },
            '& .MuiSvgIcon-root': {
              color: '#3b4559',
            },
          }}
          MenuProps={{
            sx: {
              top: 5,
              '& .MuiList-root': {
                py: 0,
              },
              '& .MuiList-root .MuiMenuItem-root': {
                py: 3,
              },
              '& .MuiList-root .MuiMenuItem-root.Mui-selected': {
                backgroundColor: 'primary.main',
                color: 'primary.contrastText',
                fontWeight: 500,
              },
            },
          }}
        >
          {careEpisodes.map((episode) => (
            <MenuItem key={episode.abaCaseId} value={episode.abaCaseId}>
              {dateRange(episode.treatmentStartDate, episode.treatmentEndDate)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

const dateRange = (startDate: Date, endDate: Date | null) => {
  if (!startDate) {
    return '';
  }
  if (!endDate) {
    return `${format(startDate, 'MM/yyyy')} - Present`;
  }
  return `${format(startDate, 'MM/yyyy')} - ${format(endDate, 'MM/yyyy')}`;
};
